<template>
    <div :id="`img-container-wrapper-${id}`" class="d-block img-container" :class="mainClasses">
        <!-- d-sm-flex flex-column flex-fill -->
        <div class="row" :class="[noSpaceBetween ? 'no-gutters' : '']">
            <template v-for="(img, idx) in items">
                <div class="w-100" v-if="lineBreak(idx) && !enableMainImage"></div>

                <FileContainer
                    :id="`img-container-${id}`"
                    :ref="`imageInput${id}`"
                    :key="`key-${id}-${idx}`"
                    :idUpload="`image-upload-${id}-${idx+1}`"
                    class="col"
                    :class="imageClasses(idx)"
                    :disabled="disabled"
                    @removeFile="onRemoveImage"
                    @createImage="onCreateImage"
                    @updateImage="onUpdateImage"
                    @preview="onShowLightbox"
                    :fileIndex="idx"
                    :maxFiles="maxImage"
                    :multiple="multiple"
                    :targetFile="photos[idx]"
                    :fileList="photos"
                    :showLimitMessage="showImageLimitMessage"
                    :showDeleteButton="activeDeleteButton"
                    :showEditButton="activeEditButton"
                    :accept="accept"
                    :fileClass="imageClass"
                    :capture="captureMediaAttribute"
                    :filenameProperty="filenameProperty"
                    :pathProperty="pathProperty"
                    :typeProperty="typeProperty"
                />

                <div class="w-100" v-if="lineBreak(idx) && !enableMainImage"></div>
            </template>
        </div>

        <VueEasyLightbox
            v-if="lightBoxVisible"
            :visible="openImage"
            :index="imageIndex"
            :imgs="arrLightBox"
            :moveDisabled="false"
            @hide="handleLightboxHide"
        />
    </div>
</template>
<script>
import cloneDeep from 'lodash-es/cloneDeep';

export default {
    name: 'UploadMultipleImage',
    components: {
        VueEasyLightbox: () => import(/* webpackChunkName: "vue-easy-lightbox" */ 'vue-easy-lightbox'),
        FileContainer: () => import(/* webpackChunkName: "file-container" */ './FileContainer.vue'),
    },
    props: {
        dragText: {
            type: String,
            default: 'Arrastar imagem'
        },
        browseText: {
            type: String,
            default: '(ou) Selecione'
        },
        primaryText: {
            type: String,
            default: 'Padrão'
        },
        markIsPrimaryText: {
            type: String,
            default: 'Definir como padrão'
        },
        popupText: {
            type: String,
            default: 'Esta imagem será exibida como padrão'
        },
        dropText: {
            type: String,
            default: 'Solte seus arquivos aqui ...'
        },
        accept: {
            type: String,
            default: 'image/gif,image/jpeg,image/png,image/bmp,image/jpg,image/svg+xml'
        },
        value: {
            type: Array,
            default: () => {
                return []
            }
        },
        dataImages: {
            type: Array,
            default: () => {
                return []
            }
        },
        showPrimary: {
            type: Boolean,
            default: true
        },
        maxImage: {
            type: Number,
            default: 1
        },
        idUpload: {
            type: String,
            default: 'image-upload'
        },
        idEdit: {
            type: String,
            default: 'image-edit'
        },
        noOverlay: {
            type: Boolean,
            default: false,
        },
        mobile: {
            type: Boolean,
            default: false
        },
        lightBoxVisible: {
            type: Boolean,
            default: true
        },
        imagesPerRow: {
            type: Number,
            default: 4
        },
        enableMainImage: {
            type: Boolean,
            default: true
        },
        showDeleteButton: {
            type: Boolean,
            default: true
        },
        showEditButton: {
            type: Boolean,
            default: true
        },
        showImageLimitMessage: {
            type: Boolean,
            default: false
        },
        imageSize: {
            type: String,
            default: 'large',
            validator: function (prop) {
                let valid = [
                    'small',
                    'medium',
                    'large',
                ];
                return valid.includes(prop);
            }
        },
        imageClass: {
            type: String,
            default: 'background-cover'
        },
        direction: {
            type: String,
            default: 'vertical',
            validator: function (prop) {
                let valid = [
                    'vertical',
                    'horizontal',
                ];
                return valid.includes(prop);
            }
        },
        disabled: {
            type: Boolean,
            default: false
        },
        heightAuto: {
            type: Boolean,
            default: false
        },
        noSpaceBetween: {
            type: Boolean,
            default: false
        },
        capture: {
            type: String,
            default: '',
            validator: function (prop) {
                let valid = [
                    'capture', //the camera app
                    'user', // The user-facing camera and/or microphone should be used.
                    'environment', // The outward-facing camera and/or microphone should be used
                ];
                return !prop || prop && valid.includes(prop);
            }
        },
        pathProperty: {
            type: String,
            default: 'path'
        },
        typeProperty: {
            type: String,
            default: 'type'
        },
        filenameProperty: {
            type: String,
            default: 'name'
        },
        extraNewProperties: {
            type: Object,
            default: () => {
                return {};
            }
        },
    },
    data() {
        return {
            id: null,
            currentIndexImage: 0,
            photos: [],
            isDragover: false,
            openImage: false,
            imageIndex: 0,
            arrLightBox: [],
            captureMediaAttribute: null,
        }
    },
    computed: {
        items() {
            return this.disabled ? this.photos.length : this.maxImage;
        },
        multiple() {
            return this.maxImage>1;
        },
        refsInput() {
            return this.$refs[`imageInput${this.id}`];
        },
        activeEditButton(){
            return this.showEditButton && !this.disabled;
        },
        activeDeleteButton(){
            return this.showDeleteButton && !this.disabled;
        },
        mainClasses(){
            let cls = this.direction == 'horizontal' ? 'flex-sm-row flex-sm-wrap justify-content-sm-between flex-sm-grow-0 flex-sm-shrink-0' : '';
            if(this.heightAuto) {
                cls += ' height-auto';
            }
            return cls;
        },
    },
    methods: {
        callFileEvent(capture=undefined) {
            this.captureMediaAttribute = capture === undefined ? this.capture : capture;
            this.triggerInput();
        },
        triggerInput() {
            this.refsInput[this.refsInput.length - 1].callFileEvent(this.captureMediaAttribute)
        },
        lineBreak (index) {
            return index > 0 && (index % this.imagesPerRow) == 0;
        },
        imageClasses(index) {
            let classes = [];
            if (this.enableMainImage && index == 0) {
                classes.push('main-image');
                classes.push('flex-fill');
                classes.push('col-12');
            } else {
                classes.push('image-item');
                if(this.direction == 'horizontal'){
                    classes.push('flex-row');
                    classes.push('mt-0');
                }else{
                    if(this.enableMainImage){
                        classes.push('flex-row');
                        // [TODO] - melhorar isto
                        classes.push(this.items>1 ? `col-${12/(this.items-1)}` : '');
                    }else{
                        classes.push('flex-fill');
                        if(index == 0){
                            classes.push('mt-0');
                        }
                    }
                }
            }
            // if(this.activeEditButton) {
            //     classes.push('cursor-pointer');
            // }
            classes.push(this.imageSize);
            return classes.join(' ');
        },
        onShowLightbox(idx) {
            this.arrLightBox = [];
            this.imageIndex = idx;
            this.openImage = true;
            this.photos.forEach(image => {
                this.arrLightBox.push(image[this.pathProperty]);
            });
        },
        handleLightboxHide() {
            this.openImage = false;
        },
        copyValue (value) {
            this.photos = value;
        },
        preventEvent(e) {
            e.preventDefault();
            e.stopPropagation();
        },
        addFiles(files) {
            if (!this.checkNumberOfImages(file.length)) {
                return false;
            }
            // process all File objects
            for (let i = 0, len = files.length; i < len; i++) {
                const file = files[i];
                this.onCreateImage(file);
                if (!this.multiple) {
                    break;
                }
                // process image files under 300,000 bytes
                // if (file.type.indexOf("image") == 0 && file.size < 300000) {
                // ...
                // }
            }
            if (document.getElementById(this.idUpload)) {
                document.getElementById(this.idUpload).value = [];
            }
        },
        onUpdateImage(file, index) {
            let reader = new FileReader();
            let formData = new FormData();
            formData.append('file', file);

            reader.onload = (e) => {
                let dataURI = e.target.result;
                if (dataURI) {
                    this.photos[index] = {file};
                    if(this.typeProperty) {
                        this.photos[index][this.typeProperty] = file.type;
                    }
                    if(this.pathProperty) {
                        this.photos[index][this.pathProperty] = dataURI;
                    }
                    if(this.filenameProperty) {
                        this.photos[index][this.filenameProperty] = file.name;
                    }

                    this.$set(this.photos, index, this.photos[index]);

                    this.$emit('upload-success', formData, this.photos.length - 1, this.photos);
                }
            };

            reader.onerror = (e) => {
                console.error("File could not be read! Code " + e.target.error.code);
            };
            // Reading data URIs
            reader.readAsDataURL(file);
        },
        onCreateImage(file) {
            let reader = new FileReader();
            let formData = new FormData();
            formData.append('file', file);

            reader.onload = (e) => {
                let dataURI = e.target.result;
                let path = dataURI; //this.createUrl(file, dataURI);
                if (path) {
                    let newFileProps = {file: file, ...this.extraNewProperties};
                    if(this.typeProperty) {
                        newFileProps[this.typeProperty] = file.type;
                    }
                    if(this.pathProperty) {
                        newFileProps[this.pathProperty] = path;
                    }
                    if(this.filenameProperty) {
                        newFileProps[this.filenameProperty] = file.name;
                    }

                    if (!this.photos.length) {
                        this.currentIndexImage = 0;
                        this.photos.push({...newFileProps, highlight: 1, default: 1});
                    } else {
                        if (this.multiple) {
                            this.photos.push({...newFileProps, highlight: 0, default: 0});
                        } else {
                            if (this.photos.length && this.photos[this.currentIndexImage]) {
                                this.photos[this.currentIndexImage] = {...this.photos[this.currentIndexImage], ...newFileProps};
                            }
                        }
                    }
                    this.$emit('upload-success', formData, this.photos.length - 1, this.photos);
                }
            };

            reader.onerror = (e) => {
                console.error("File could not be read! Code " + e.target.error.code);
            };
            // Reading data URIs
            reader.readAsDataURL(file);
        },
        // createUrl(file, dataURI) {
        //     let fileType = file.type;
        //     if(fileType.match(/video.*/) || fileType.match(/image.*/)) {
        //         return dataURI; // URL.createObjectURL(file);
        //     } else {
        //         return this.fileIcon;
        //     }
        // },
        checkNumberOfImages(amount) {
            if (!this.multiple) {
                return true;
            }
            // if ((amount + this.photos.length) > this.maxImage) {
            if ((amount) > this.maxImage) {
                this.$emit('limit-exceeded', amount);
                return false;
            } else {
                return true;
            }
        },
        onRemoveImage(idx) {
            this.photos.splice(idx, 1);
            this.arrLightBox = [];
        },
    },
    mounted() {
        this.id = this._uid;
        this.captureMediaAttribute = this.capture,
        document.body.addEventListener('dragleave', (evt) => {
            evt.stopPropagation();
            evt.preventDefault();
            this.isDragover = false;
        })
    },
    created() {
        this.photos = [];
        this.photos = cloneDeep(this.dataImages);
    },
    beforeMount() {
      // Here we are following the Vue2 convention on custom v-model:
      // https://github.com/vuejs/vue/issues/2873#issuecomment-223759341
      this.copyValue(this.value)
    },
    watch: {
        dataImages: {
            handler: function(newVal) {
                this.photos = newVal;
            },
            deep: true
        },
        value (newValue) {
            // This watch works from the code side of the 2-way-binding:
            this.copyValue(newValue);
        }
    },

}
</script>

<style scoped lang="scss">
@import '@styles/_theme.scss';

.img-container {

    &.height-auto {
        height: 100%;
        > .row {
            height: 100%;

            .main-image {
                min-height: calc(100% - 70px - 1rem);

                &.large {
                    min-height: 70px;
                    @include sm {
                        min-height: calc(50% - 1rem);
                    }
                }
            }

            .image-item {
                // min-height: 70px;
                margin-top: 1rem;

                &.large {
                    @include sm {
                        // min-height: calc(50% - 1rem);
                        margin-top: 2rem;
                    }
                }
            }
        }
    }

    &:not(.height-auto) {
        height: 100%;

        .row {
            min-height: 100%;
            height: 100%;

            .main-image {
                &.small {
                    // min-height: 50%;
                    min-height: calc(100% - 70px - 1rem);

                    &.responsive {
                        @include sm {
                            // min-height: 55%;
                            min-height: calc(100% - 90px - 1rem)
                        }
                    }
                }

                &.medium {
                    // min-height: 80%;
                    min-height: calc(100% - 80px - 1rem);

                    &.responsive {
                        @include sm {
                            // min-height: 70%;
                            min-height: calc(100% - 110px - 1rem);
                        }
                    }

                }

                &.large {
                    // min-height: 80%;
                    min-height: calc(100% - 80px - 1rem);

                    &.responsive {
                        @include sm {
                            // min-height: 70%;
                            min-height: calc(100% - 150px - 1rem);
                        }
                    }

                }
            }

            .image-item {
                &.small {
                    height: 70px;
                    margin-top: 1rem;

                    &.responsive {
                        @include sm {
                            height: 90px;
                        }
                    }
                }

                &.medium {
                    height: 80px;

                    &.responsive {
                        @include sm {
                            height: 110px;
                        }
                    }
                }

                &.medium:nth-child(n+3) {
                    margin-top: 1.5rem;
                }

                &.large {
                    height: 80px;
                    margin-top: 1rem;

                    &.responsive {
                        @include sm {
                            height: 150px;
                            margin-top: 2rem;
                        }
                    }
                }
            }
        }
    }
}
</style>